<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="Category3" prop="category3Code">
                        <el-select v-model="queryCondition.category3Code" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.object" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Sponsor" prop="sponsorName">
                      <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="ASL Group" prop="aslGroupName">
                      <el-input v-model="queryCondition.aslGroupName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="ASL" prop="aslName">
                      <el-input v-model="queryCondition.aslName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="Ownership" prop="ownership">
                        <el-select v-model="queryCondition.ownership" clearable  filterable placeholder="请选择" style="width:100%">
                            <el-option :key="index" v-for="(item,index) in ownershipOptions" :label="item.object" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="国内/国外" prop="domesticOrOverseas">
                        <el-select v-model="queryCondition.domesticOrOverseas" clearable  filterable placeholder="请选择" style="width:100%">
                            <el-option :key="index" v-for="(item,index) in domesticOrOverseas" :label="item.object" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="状态" prop="aslStatus">
                        <el-select v-model="queryCondition.aslStatus" clearable  filterable placeholder="请选择" style="width:100%">
                            <el-option :key="index" v-for="(item,index) in statusList" :label="item.object" :value="item.key"></el-option>
                        </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button  size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button v-acl="RMC_ASL_ADD"  class="btn" type="primary" @click="addList">新增</el-button>
        <el-button v-acl="RMC_ASL_DELETE"   class="btn" type="danger" @click="onDel">删除</el-button>
        <el-button v-acl="RMC_ASL_SAVE"  class="btn" type="primary" @click="changeStatus(1)">启用</el-button>
        <el-button v-acl="RMC_ASL_SAVE"  class="btn" type="primary" @click="changeStatus(2)">禁用</el-button>
        <el-button v-acl="RMC_ASL_EXPORT"  class="btn" type="primary" @click="exportData">导出</el-button>
        <el-button v-acl="RMC_ASL_GEN_TASK"  class="btn" type="primary" @click="generateTodoList">生成待办任务</el-button>
        <el-button v-acl="RMC_ASL_DEL_TASK"  class="btn" type="primary" @click="deleteTodoList">删除待办任务</el-button>
        <!--  -->
        <el-button v-acl="RMC_ASL_BREEDING_CONFIG" class="btn" type="primary" @click="viewAslAuthConfig">授权配置</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="Category3" field="category3Name"  width="120" />
        <ux-table-column align="center" title="Sponsor" min-width="100" field="sponsorName"></ux-table-column>
        <ux-table-column align="center" title="ASL Group" min-width="120" field="aslGroupName"></ux-table-column>
        <ux-table-column align="center" title="ASL" min-width="140" field="aslName">
            <template v-slot="scope">
                <el-button type="text" @click="openDetail(scope.row)">{{scope.row.aslName}}</el-button>
            </template>
        </ux-table-column>
        <ux-table-column align="center" title="养殖模式" min-width="130" field="">
          <template v-slot="scope">
            <div style="display: flex;justify-content: center;flex-wrap: wrap;">
              <div style="margin: 5px;" v-for="item in scope.row.mainBreedingModes">
                <el-tag type="info">{{item | modeFilter(breedingModeOptions)}}</el-tag>
              </div>
            </div>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="Ownership" min-width="100" field="ownership"></ux-table-column>
        <ux-table-column align="center" title="国内/国外" min-width="120" field="domesticOrOverseasView"></ux-table-column>
        <ux-table-column align="center" title="国家" min-width="100" field="countryRegion"></ux-table-column>
        <ux-table-column align="center" title="状态" min-width="120" field="aslStatus"></ux-table-column>
        <ux-table-column align="center" title="修改原因" min-width="120" field="updateReason"></ux-table-column>
        <ux-table-column align="center" title="更新人" min-width="120" field="updateName"></ux-table-column>
        <ux-table-column align="center" title="更新时间" min-width="120" field="updateDate"></ux-table-column>
        <ux-table-column align="center" title="关联数据" min-width="120" field="createDate">
            <template v-slot="scope">
                <el-button type="text" @click="examine(scope.row)">查看</el-button>
            </template>
        </ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>

      <!-- ASL授权配置 -->
      <el-dialog title="ASL授权配置" :visible.sync="aslAuthConfigDisplay" append-to-body width="90%" :close-on-click-modal="false">
        <aslAuthConfig v-if="aslAuthConfigDisplay" :categoryList="categoryList3" :breedingModeOptions="breedingModeOptions"></aslAuthConfig>
      </el-dialog>
    
    <el-dialog title="提示" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
        <div slot="title" class="header-title">
            <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
                <p class="line"></p>
                <p class="info_title">ASL关联数据查看</p>
            </div>
        </div>
        <ux-grid v-if="dialogVisible" ref="plxTable" :data="dialogTable" max-height="500" show-overflow="tooltip" highlight-current-row>
            <ux-table-column align="center" title="关联数据" min-width="100" field="name"></ux-table-column>
            <ux-table-column align="center" title="已有数据" min-width="100" field="code"></ux-table-column>
            <ux-table-column align="center" title="操作" min-width="100" >
                <template v-slot="scope">
                    <el-button type="text" @click="goPage(scope.row)">查看</el-button>
                </template>
            </ux-table-column>
        </ux-grid>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="exportDialog" width="30%" >
        <div slot="title" class="header-title">
            <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
                <p class="line"></p>
                <p class="info_title">选择季度</p>
            </div>
        </div>
        <el-form :model="ruleForm" :inline="true" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="年" prop="year">
            <el-date-picker :disabled="isBool?true:false" style="width:200px" value-format="yyyy" v-model="ruleForm.year" type="year" placeholder="选择年"> </el-date-picker>
          </el-form-item>
          <el-form-item label="季度" prop="quarter">
            <el-select :disabled="isBool?true:false" v-model="ruleForm.quarter"  clearable placeholder="请选择" style="width:200px">
              <el-option :key="index" v-for="(item,index) in quarterList" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-row type="flex" justify="center" align="middle">
            <el-button type="primary" @click="exportFarm('ruleForm')">导出</el-button>
            <el-button @click="exportDialog=false">取消</el-button>
          </el-row>
        </el-form>
        
    </el-dialog>



    </div>
  </div>
</template>
<script>
import aslApi from "@/api/rmcProtein/asl"; 
import commonFunction from "@/utils/dataTableUtils";
import updateDialog from '@/components/page/RMC/Protein/rmcDrugList/updateDialog'
import QBRApi from "@/api/QBR/index";
import { fileService } from "@/api/common/file-utils";
import moment from "moment";
import aslAuthConfig from "@/components/page/RMC/Protein/ASL/dialog/aslAuthConfig.vue";

export default {
  name: '',
  components: {
    updateDialog,
    // detailDialog,
    aslAuthConfig,
  },
  data() {
    return {
      ruleForm:{},
      quarterList:[{
        name:"Latest",
        code:"0"
      },{
        name:"Q1",
        code:"1"
      },{
        name:"Q2",
        code:"2"
      },{
        name:"Q3",
        code:"3"
      },{
        name:"Q4",
        code:"4"
      }],
      exportDialog:false,
      dialogTable:[{
        name:"RMC评分",
        value:'1'
      },{
        name:"采购量",
        value:'2'
      },{
        name:"农场清单",
        value:'3'
      },{
        name:"饲料厂清单",
        value:'4'
      },{
        name:"审核员清单",
        value:'5'
      },{
        name:"药品清单",
        value:'6'
      },{
        name:"药品用量",
        value:'7'
      },{
        name:"ASL审核报告",
        value:'8'
      }],
      isBool:"",
      identity:localStorage.getItem('ms_emplFlag'),
      ms_roles :JSON.parse(localStorage.getItem('ms_roles')),
      dialogVisible:false,
      multipleSelection:[],
      categoryList2: [],
      categoryList3: [],
      domesticOrOverseas:[],
      statusList: [],
      ownershipOptions:[],
      queryCondition: {
        category3Code:'',
        sponsorName:'',
        aslGroupName:"",
        aslName:"",
        ownership:'',
        domesticOrOverseas:"",
        aslStatus:'',
        pageNum: 1,
        pageSize: 15,
      },
      isShow: false,
      tableData: [],
      totalCount:"",
      routerData:{},
      rules: {
          year: [
            { required: true, message: '请选择年份', trigger: 'change' }
          ],
          quarter: [
            { required: true, message: '请选择季度', trigger: 'change' }
          ],
      },

      aslAuthConfigDisplay: false,
      breedingModeOptions: [],
    }
  },
  filters: {
    modeFilter(str, breedingModeOptions) {
      let modeObj = breedingModeOptions.find(mode => mode.key === str);
      if(modeObj) {
        return modeObj.object;
      } else {
        return str;
      }
    }
  },
  created() {
    let newDialogTable=this.dialogTable
    //供应商buyer的只能看采购量  PORK/CHICK/PRODUCE
    if((this.ms_roles.indexOf('QSPI_RMC_PORK_BUYER_SUPP')!=-1||this.ms_roles.indexOf('QSPI_RMC_CHICK_BUYER_SUPP')!=-1)&&(this.ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!=-1||this.ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!=-1)){
        this.dialogTable=newDialogTable
    }else if(this.ms_roles.indexOf('QSPI_RMC_PORK_BUYER_SUPP')!=-1||this.ms_roles.indexOf('QSPI_RMC_CHICK_BUYER_SUPP')!=-1){
      this.dialogTable=[{
         name:"采购量",
         value:'2'
      }]
    }else if(this.ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!=-1||this.ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!=-1){
      this.dialogTable.splice(1,1)
    }
    this.queryData();
    this.getCategory3Lists()
  },
  methods: {
    queryData(val) {
      if(undefined != val){
        this.queryCondition.pageNum=1
      }
      aslApi.getAslData(this.queryCondition).then((res)=>{
        this.tableData=res.resultData
        this.totalCount=res.totalCount
      })
    },
    onGrade(row){
      sessionStorage.setItem("taskDetail",JSON.stringify(row))
      this.$router.push({
          path:"/rmcDrugDosage/detail",
          query:{

          }
      })
    },
    onReset() {
      this.queryCondition={
        category3Code:'',
        sponsorName:'',
        aslGroupName:"",
        aslName:"",
        ownership:'',
        domesticOrOverseas:"",
        aslStatus:'',
        pageNum: 1,
        pageSize: 15,
      }
      // this.$refs['queryCondition'].resetFields();
      this.queryData();
    },
    addList() {
      this.$router.push({
          path:"/rmcProtASL/detail",
          query:{

          }
      })
    },
    openDetail(row){
        this.$router.push({
            path:"/rmcProtASL/detail",
            query:{
                id:row.rmcProteinAslId
            }
        })
    },
    pageSizeChange(val){
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val){
      this.queryCondition.pageNum = val
      this.queryData()
    },
    
    changeStatus(val){
      let params={
        rmcProteinAslIds:[],
        updateReason:""
      }
      this.multipleSelection.forEach((v)=>{
        params.rmcProteinAslIds.push(v.rmcProteinAslId)
      })
      if(val==1){  //启用
        let strList=[]
        let num=0
        let statusList=[]
        this.statusList.forEach((v)=>{
          statusList.push(v.key)
        })
        this.multipleSelection.forEach((v)=>{
          strList.push(v.aslStatus)
        })
        let isInactive=this.multipleSelection.every((v)=>{
          return v.aslStatus=='Inactive'
        })
        new Set(strList).forEach((v)=>{
          if(v=='Inactive'||v=='Draft'||v=='New'||v=='Active'||v=='Delist'){
            num++
          }
        })
        if(num>1){
          this.$message.error('已勾选的数据状态不一致，请检查！')
        }else{
          if(isInactive){
            this.$prompt('', '请填写修改原因', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputValidator: (value) => {  
                if(!value&&isInactive) {
                  return '修改原因不能为空！';
                }
              },
            }).then(({ value }) => {
              params.updateReason=value
              aslApi.aslActive(params).then((res)=>{
                if(res.meta.code==200){
                  this.$message.success('启用成功')
                  this.queryData()
                }else{
                  this.$message.error(res.meta.msg)
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              });       
            });
          }else{
             aslApi.aslActive(params).then((res)=>{
                if(res.meta.code==200){
                  this.$message.success('启用成功')
                  this.queryData()
                }else{
                  this.$message.error(res.meta.msg)
                }
              })
          }
          
        }

      }else if(val==2){   //禁用
        let num=0
        let strList=[]
        let isActive=this.multipleSelection.every((v)=>{
          return v.aslStatus=='Active'
        })
        let isNew=this.multipleSelection.every((v)=>{
          return v.aslStatus=='New'
        })
        this.multipleSelection.forEach((v)=>{
          strList.push(v.aslStatus)
        })
         new Set(strList).forEach((v)=>{
          if(v=='Inactive'||v=='Draft'||v=='New'||v=='Active'||v=='Delist'){
            num++
          }
        })
        if(num>1){
            this.$message.error('存在状态不一致的主数据无法同时禁用，请检查')
            // this.$message.error('主数据状态为New或者Active时才允许禁用，请检查。')
        }else{
          if(isActive||isNew){
            this.$prompt('', '请填写修改原因', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputValidator: (value) => {  
                if(!value) {
                  return '修改原因不能为空！';
                }
              },
            }).then(({ value }) => {
              params.updateReason=value
              aslApi.aslInactive(params).then((res)=>{
                  if(res.meta.code==200){
                    this.$message.success('禁用成功')
                    this.queryData()
                  }else{
                    this.$message.error(res.meta.msg)
                  }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              });       
            });
          }else{
            this.$message.error('主数据状态为New或者Active时才允许禁用，请检查。')
          }
          
        }
      }

      // this.$prompt('', '请填写修改原因', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     inputValidator: (value) => {  
      //       if(!value) {
      //         return '修改原因不能为空！';
      //       }
      //     },
      //   }).then(({ value }) => {
      //     params.updateReason=value
      //       aslApi.aslActive(params).then((res)=>{
      //         if(res.meta.code==200){
      //           this.$message.success('启用成功')
      //           this.queryData()
      //         }else{
      //           this.$message.error(res.meta.msg)
      //         }
      //       })
      //   }).catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '取消输入'
      //     });       
      //   });
    },
    getDeleteStatus(){
      // 判断是否关联
      // isRmcScoreMaintained
      // isPurchaseVolumeMaintained
      // isFarmMaintained
      // isFeedFactoryMaintained
      // isAuditorMaintained
      // isDrugListMaintained
      // isDrugDosageMaintained
      // isThirdPartyAuditReport
      for(let i=0;i<this.multipleSelection.length;i++){
        if(this.multipleSelection[i].isEnabled=='Y'){
          return 3
        }else if(this.multipleSelection[i].isRmcScoreMaintained=='Y'||this.multipleSelection[i].isPurchaseVolumeMaintained=='Y'||this.multipleSelection[i].isFarmMaintained=='Y'||this.multipleSelection[i].isFeedFactoryMaintained=='Y'||this.multipleSelection[i].isAuditorMaintained=='Y'||this.multipleSelection[i].isDrugListMaintained=='Y'||this.multipleSelection[i].isDrugDosageMaintained=='Y'||this.multipleSelection[i].isThirdPartyAuditReport=='Y'){
          return 2
        }else{
          return 1
        }
      }
    },
    onDel() {
      if(this.multipleSelection.length==0){
        this.$message.error('请先选择数据后再操作')
      }else{
        let status=this.getDeleteStatus()
        let params={
          rmcProteinAslIds:[],
          updateReason:""
        }
        this.multipleSelection.forEach((v)=>{
          console.log("vvvvvvvv",v)
          params.rmcProteinAslIds.push(v.rmcProteinAslId)
        })
        // let isCreate=this.multipleSelection.some((v)=>{
        //   return v.aslStatus!='Draft'
        // })
        let count=0
        this.multipleSelection.forEach((v)=>{
          if(v.aslStatus=='New'||v.aslStatus=='Inactive'||v.aslStatus=='Delist'){
            count++
          }
        })
        if(count!=0){
          this.$message.error('仅可以删除状态为Draft和Active的主数据，请检查！')
        }else{
          if(status==1){
            this.$confirm('请确认是否删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              customClass: 'colorBtn',
              cancelButtonClass: 'btn_custom_cancel',
              type: 'warning'
            }).then(() => {
              aslApi.aslDelete(params).then((res)=>{
                if(res.meta.code==200){
                  this.$message.success('删除成功')
                  this.multipleSelection=[]
                  this.queryData()
                }else{
                  this.$message.error(res.meta.msg)
                }
              })
            })
            
          }else if(status==2){
            this.$confirm('请确认是否删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              aslApi.aslDelete(params).then((res)=>{
                if(res.meta.code==200){
                  this.$message.success('删除成功')
                  this.multipleSelection=[]
                  this.queryData()
                }else{
                  this.$message.error(res.meta.msg)
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
          }else if(status==3){
            this.$prompt('', '请填写修改原因', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputValidator: (value) => {  
                if(!value) {
                  return '修改原因不能为空！';
                }
              },
            }).then(({ value }) => {
              this.$confirm('请确认是否删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              customClass: 'colorBtn',
              cancelButtonClass: 'btn_custom_cancel',
              type: 'warning'
            }).then(() => {
              params.updateReason=value
              aslApi.aslDelete(params).then((res)=>{
                if(res.meta.code==200){
                  this.$message.success('删除成功')
                  this.multipleSelection=[]
                  this.queryData()
                }else{
                  this.$message.error(res.meta.msg)
                }
              })
            })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              });       
            });
          }
        }
      }
      
    },
    generateTodoList(){
      let isCreate=this.multipleSelection.some((v)=>{
        return v.aslStatus!='New'
      })
      if(isCreate){
        this.$message.error('请选择New状态的数据生成')
      }else{
        let params={
          rmcProteinAslIds:[]
        }
        this.multipleSelection.forEach((v)=>{
          params.rmcProteinAslIds.push(v.rmcProteinAslId)
        })
        aslApi.generateTodoList(params).then((res)=>{
          if(res.meta.code==200){
            this.$message.success('生成待办任务')
            this.multipleSelection=[]
            this.queryData()
          }else{
            this.$message.error(res.meta.msg)
          }
        })
      }
      
    },
    deleteTodoList(){
      let params={
        rmcProteinAslIds:[]
      }
      this.multipleSelection.forEach((v)=>{
        params.rmcProteinAslIds.push(v.rmcProteinAslId)
      })
      aslApi.deleteTodoList(params).then((res)=>{
        if(res.meta.code==200){
          this.$message.success('删除待办任务')
          this.multipleSelection=[]
          this.queryData()
        }else{
          this.$message.error(res.meta.msg)
        }
      })
    },
    exportData(){
      this.exportDialog=true
      if( this.ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!=-1|| this.ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!=-1 ){
        this.isBool=true
        this.ruleForm.year=moment().format("YYYY") 
        this.ruleForm.quarter='0'
      }else{
        this.isBool=false
      }
    },
    exportFarm(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            let arr=[]
            this.multipleSelection.forEach((v)=>{
              arr.push(v.rmcProteinAslId)
            })
            let str=this.quarterList.filter((v)=>{
              return v.code==this.ruleForm.quarter
            })
            let newObj=Object.assign(this.queryCondition,this.ruleForm)
            newObj.rmcProteinAslIds=arr
            aslApi.downloadAsl(newObj).then((res)=>{
                fileService.respToFile(res,'ASL主数据'+'_'+this.ruleForm.year+'_'+str[0].name+'.xlsx');
                this.exportDialog=false
            })
          } else {
            console.log('error submit!!');
            return false;
          }
      });
    },
    selectionChange(val){
      this.multipleSelection=val
    },
    handleClose(){
      this.dialogVisible=false
      this.queryData()
    },
    examine(row){
      this.routerData=row
        aslApi.getRmcReferenceList(row.rmcProteinAslId).then((res)=>{
          if(res.code==200){
            if((this.ms_roles.indexOf('QSPI_RMC_PORK_BUYER_SUPP')!=-1||this.ms_roles.indexOf('QSPI_RMC_CHICK_BUYER_SUPP')!=-1)&&(this.ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!=-1||this.ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!=-1)){
              this.dialogTable[0].code=res.data.isRmcScoreMaintained
              this.dialogTable[1].code=res.data.isPurchaseVolumeMaintained
              this.dialogTable[2].code=res.data.isFarmMaintained
              this.dialogTable[3].code=res.data.isFeedFactoryMaintained
              this.dialogTable[4].code=res.data.isAuditorMaintained
              this.dialogTable[5].code=res.data.isDrugListMaintained
              this.dialogTable[6].code=res.data.isDrugDosageMaintained
              this.dialogTable[7].code=res.data.isThirdPartyAuditReport
           }else if(this.ms_roles.indexOf('QSPI_RMC_PORK_BUYER_SUPP')!=-1||this.ms_roles.indexOf('QSPI_RMC_CHICK_BUYER_SUPP')!=-1||this.ms_roles.indexOf('QSPI_RMC_PRODUCE_BUYER_SUPP')!=-1){
              this.dialogTable[0].code=res.data.isPurchaseVolumeMaintained
            }else if(this.ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!=-1||this.ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!=-1){
              this.dialogTable[0].code=res.data.isRmcScoreMaintained
              this.dialogTable[1].code=res.data.isFarmMaintained
              this.dialogTable[2].code=res.data.isFeedFactoryMaintained
              this.dialogTable[3].code=res.data.isAuditorMaintained
              this.dialogTable[4].code=res.data.isDrugListMaintained
              this.dialogTable[5].code=res.data.isDrugDosageMaintained
              this.dialogTable[6].code=res.data.isThirdPartyAuditReport
            }else{
              this.dialogTable[0].code=res.data.isRmcScoreMaintained
              this.dialogTable[1].code=res.data.isPurchaseVolumeMaintained
              this.dialogTable[2].code=res.data.isFarmMaintained
              this.dialogTable[3].code=res.data.isFeedFactoryMaintained
              this.dialogTable[4].code=res.data.isAuditorMaintained
              this.dialogTable[5].code=res.data.isDrugListMaintained
              this.dialogTable[6].code=res.data.isDrugDosageMaintained
              this.dialogTable[7].code=res.data.isThirdPartyAuditReport
            }
            this.dialogVisible=true
          }else{
            this.$message.error(res.msg)
          }
        })
    },
    goPage(val){
      console.log("vvvvvvv",this.routerData)
      this.$store.dispatch('saveQueryData',this.routerData)
      if(val.value==1){
        this.$router.push({
          path:"rmcProtScore"
        })
      }else if(val.value==2){
        this.$router.push({
          path:"rmcProtPcQty",
          query: {
            // category3Code: this.routerData.category3Code,
            sponsorName:this.routerData.sponsorName
          }
        })
      }else if(val.value==3){
        this.$router.push({
          path:"rmcProtFarm",
          query: {
            // category3Code: this.routerData.category3Code,
            // sponsorName: this.routerData.sponsorName,
            aslGroupName: this.routerData.aslGroupName,
          }
        })
      }else if(val.value==4){
        this.$router.push({
          path:"rmcProtFeedPlant",
          query: {
            // category3Code: this.routerData.category3Code,
            // sponsorName: this.routerData.sponsorName,
            aslGroupName: this.routerData.aslGroupName,
          }
        })
      }else if(val.value==5){
        this.$router.push({
          path:"rmcProtAuditor",
          query: {
            // category3Code: this.routerData.category3Code,
            // sponsorName: this.routerData.sponsorName,
            aslGroupName: this.routerData.aslGroupName,
          }
        })
      }else if(val.value==6){
        this.$router.push({
          path:"rmcProtMedicine"
        })
      }else if(val.value==7){
        this.$router.push({
          path:"rmcProtMedUsage"
        })
      }else if(val.value==8){
        this.$router.push({
          path:"rmcProt3P"
        })
      }
    },
    getCategory3Lists() {
      aslApi.getCategory3(['rmc.RmcCategory3','rmc.RmcProteinAslOwnership','rmc.RmcDomesticOrOverseas','rmc.RmcProteinAslStatus','rmc.RmcFarmBreedingMode']).then((res)=>{
        if(res.code==200){
          this.categoryList3=res.data['rmc.RmcCategory3'].filter((v)=>{
            return v.cascadeKey=='protein'
          })
          this.domesticOrOverseas=res.data['rmc.RmcDomesticOrOverseas']
          this.ownershipOptions=res.data['rmc.RmcProteinAslOwnership']
          this.statusList=res.data['rmc.RmcProteinAslStatus']
          this.breedingModeOptions = res.data['rmc.RmcFarmBreedingMode'];
        }else{
          this.$message.error(res.msg)
        }
        console.log("获取的列表====",res)
      })
    },
    viewAslAuthConfig() {
      this.aslAuthConfigDisplay = true;
    }
  },
  extends: commonFunction
}
</script>
<style scoped >
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
